import "./App.scss";

import ContextProvider from "./context/Context";
import Routers from "./routers/Router";
import { App as AntdApp } from "antd";
import ComingSoon from "./components/comingsoon/ComingSoon";

function App() {
  return (
    <>
      <div className="App">
        <AntdApp>
          <ContextProvider>
            <Routers />
          </ContextProvider>
        </AntdApp>
      </div>
      <ComingSoon />
    </>
  );
}

export default App;
